import styles from './PageSections.module.css';

export const SECTION_IDS = {
  WHO_ARE_WE: 'who-are-we',
  SOUND_SYSTEM: 'sound-system',
  VENUE_FEATURES: 'venue-features',
  HOUSE_RULES: 'house-rules',
} as const;

export function PageSections() {
  return (
    <div className={styles.sectionsWrapper}>
      <div className={styles.divider} />

      <section id={SECTION_IDS.WHO_ARE_WE} className={styles.section}>
        <h2 className={styles.sectionTitle}>Who Are We</h2>
        <div className={styles.sectionBody}>
          <p>
            REFUGE is an underground music collective rooted in New York City.
            We curate immersive experiences that blur the line between audience
            and artist — a sanctuary for those who live for the night.
          </p>
          <p>
            Born from the city's deep electronic music culture, REFUGE is a
            space where sound, community, and expression converge without
            compromise.
          </p>
        </div>
      </section>

      <section id={SECTION_IDS.SOUND_SYSTEM} className={styles.section}>
        <h2 className={styles.sectionTitle}>Sound System</h2>
        <div className={styles.sectionBody}>
          <p>
            Our sound system is purpose-built for the room — tuned, treated,
            and calibrated to deliver uncompromising audio at every frequency.
          </p>
          <p>
            We believe the system is the instrument. Every event is
            engineered for full-spectrum immersion from sub-bass to high-end
            clarity.
          </p>
        </div>
      </section>

      <section id={SECTION_IDS.VENUE_FEATURES} className={styles.section}>
        <h2 className={styles.sectionTitle}>Venue Features</h2>
        <div className={styles.sectionBody}>
          <ul>
            <li>Purpose-built sound system</li>
            <li>Intimate capacity</li>
            <li>Full bar service</li>
            <li>Climate-controlled environment</li>
            <li>Professional lighting rig</li>
            <li>Accessible entrance</li>
          </ul>
        </div>
      </section>

      <section id={SECTION_IDS.HOUSE_RULES} className={styles.section}>
        <h2 className={styles.sectionTitle}>House Rules</h2>
        <div className={styles.sectionBody}>
          <ul>
            <li>Respect the space and each other</li>
            <li>No photos or videos on the dance floor</li>
            <li>No harassment of any kind — zero tolerance</li>
            <li>Stay hydrated — free water always available</li>
            <li>Look after one another</li>
            <li>Dance like nobody's watching</li>
          </ul>
        </div>
      </section>
    </div>
  );
}
